module.exports = __webpack_public_path__ + "img/IMG_3498.e79efb34.jpg";